import React, { useEffect, useState } from "react"
import AuthService from "./services/auth.service"

/*
	Contraseña temporal (Esteban, 2026-10-12). Cuando quien administra al personal le pone a alguien una contraseña
	temporal, al entrar con ella WAPP no deja hacer nada hasta escribir una propia: el servidor contesta 403
	"cambiar_clave" a todo lo demás (SesionActiva) y esta pantalla tapa la app.

	Se enciende por dos caminos: los datos de la sesión traen bool_cambiar_clave = 1 (al entrar o al recargar), o
	cualquier petición recibe ese 403 (guardiaDeSesion).
*/
let pendiente = false
const oyentes = new Set<(v: boolean) => void>()

export const marcarCambioDeClave = (usuario?: any) => {
	if (usuario !== undefined && !(usuario && Number(usuario.bool_cambiar_clave) === 1)) return
	if (pendiente) return
	pendiente = true
	oyentes.forEach((f) => f(true))
}

const CambioDeClaveObligatorio: React.FC = () => {
	const [abierto, setAbierto] = useState(pendiente)
	const [clave, setClave] = useState("")
	const [otra, setOtra] = useState("")
	const [error, setError] = useState<string | null>(null)
	const [ocupado, setOcupado] = useState(false)

	useEffect(() => {
		oyentes.add(setAbierto)
		setAbierto(pendiente)
		return () => { oyentes.delete(setAbierto) }
	}, [])

	if (!abierto) return null

	const guardar = async (e: React.FormEvent) => {
		e.preventDefault()
		if (clave.length < 8) { setError("Usa al menos 8 caracteres."); return }
		if (clave !== otra) { setError("Las dos contraseñas no coinciden."); return }
		setOcupado(true); setError(null)
		try {
			await AuthService.cambiarClave(clave, otra)
			pendiente = false
			// Todo lo que la app pidió mientras tanto recibió 403: se recarga limpio.
			window.location.reload()
		} catch (x: any) {
			setError(x?.response?.data?.message || "No se pudo guardar. Revisa tu conexión e intenta otra vez.")
			setOcupado(false)
		}
	}

	return (
		<div className="waClaveFondo" role="dialog" aria-modal="true" aria-labelledby="waClaveTit">
			<form className="waClaveCaja" onSubmit={guardar}>
				<h2 id="waClaveTit">Crea Tu Contraseña</h2>
				<p>Entraste con una contraseña temporal. Escribe una propia para seguir.</p>
				<label htmlFor="waClave1">Nueva contraseña</label>
				<input id="waClave1" type="password" autoComplete="new-password" minLength={8} maxLength={50} required autoFocus
					value={clave} onChange={(e) => setClave(e.target.value)} disabled={ocupado} />
				<label htmlFor="waClave2">Confírmala</label>
				<input id="waClave2" type="password" autoComplete="new-password" minLength={8} maxLength={50} required
					value={otra} onChange={(e) => setOtra(e.target.value)} disabled={ocupado} />
				{error ? <div className="waClaveError">{error}</div> : null}
				<button type="submit" className="waClaveBoton" disabled={ocupado}>{ocupado ? "Guardando…" : "Guardar Contraseña"}</button>
			</form>
			{/* La etiqueta global label es absoluta: sin position:static las dos etiquetas
			    quedaban encimadas sobre el titulo. Colores con tokens para el modo oscuro.
			    (Esteban, 2026-10-22) */}
			<style>{`
				.waClaveFondo{position:fixed;inset:0;z-index:20000;background:rgba(20,20,30,.55);display:flex;align-items:center;justify-content:center;padding:16px}
				.waClaveCaja{background:var(--wa-superficie);color:var(--wa-tinta);border-radius:16px;max-width:380px;width:100%;padding:24px;box-shadow:0 12px 40px rgba(0,0,0,.25);display:flex;flex-direction:column;gap:8px;font-family:"Hanken Grotesk",Arial,sans-serif}
				.waClaveCaja h2{font-family:"Bricolage Grotesque","Hanken Grotesk",sans-serif;font-size:22px;margin:0 0 4px}
				.waClaveCaja p{margin:0 0 8px;color:var(--wa-apagado);font-size:14px}
				.waClaveCaja label{position:static;white-space:normal;color:var(--wa-tinta);font-size:13px;font-weight:600;margin-top:4px}
				.waClaveCaja input{border:1px solid var(--wa-filo-2);background:var(--wa-superficie);color:var(--wa-tinta);border-radius:10px;padding:10px 12px;font-size:15px;width:100%}
				.waClaveCaja input:focus{outline:2px solid var(--wa-acento);border-color:var(--wa-acento)}
				.waClaveError{color:var(--wa-oro);font-size:13px}
				.waClaveBoton{margin-top:10px;background:var(--wa-acento);color:#fff;border:0;border-radius:999px;padding:11px 16px;font-weight:600;font-size:15px}
				.waClaveBoton:disabled{opacity:.6}
			`}</style>
		</div>
	)
}

export default CambioDeClaveObligatorio
